import FacetsComponent from "./Facets";
import JobApplicationComponent from "./JobApplication";
import { JobApplicationProps } from "./JobApplication/JobApplication";
import OpenPositionCardComponent, {
  OpenPositionCardProps,
} from "./OpenPositionCard";

// Cast to fix React 17 + @types/react 18 compatibility issue
const Facets = FacetsComponent as any;
const JobApplication = JobApplicationComponent as any;
const OpenPositionCard = OpenPositionCardComponent as any;
import {
  OpenPositionsContainer,
  OpenPositionsList,
  PageHeading,
} from "./styles";
import useSWR from "swr";
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks";
import { setAllJobsFilters } from "@/lib/redux/jobsFilters/jobsFiltersSlice";
import { jobsFilterSelectors } from "@/lib/redux/store";
import { useCallback } from "react";

export type OpenPositionsProps = {
  id: string | null;
  heading: string | null;
  jobApplication: JobApplicationProps | {};
};

const ID_TO_EXCLUDE = 226017;

const fetcher = (url: string) => fetch(url).then((res) => res.json());
type JobsProps = {
  status: number;
  positions: OpenPositionCardProps[];
  web_url: string;
};

const OpenPositions: React.FC<OpenPositionsProps> = (props) => {
  const { heading, jobApplication } = props;

  const dispatch = useAppDispatch();
  const filters = useAppSelector(jobsFilterSelectors.selectAll);

  const { data, error } = useSWR<JobsProps>("/api/jobs", fetcher, {
    onSuccess(data) {
      // Get array of unique countries
      const countries = new Set<string>();
      data.positions.forEach((position) => {
        const { country } = position.location;
        if (country) {
          countries.add(country);
        }
      });
      dispatch(
        setAllJobsFilters([
          {
            id: "Country",
            selectedValues: [],
            values: Array.from(countries),
          },
        ])
      );
    },
  });

  const isSelected = useCallback(
    (filterId: string, value: string) => {
      const filter = filters.find((filter) => filter.id === filterId);
      if (filter) {
        return (
          filter.selectedValues.length === 0 ||
          filter.selectedValues.includes(value)
        );
      } else {
        return false;
      }
    },
    [filters]
  );

  // TODO better component composition and loading states
  if (error) {
    console.error(error);
    return (
      <OpenPositionsContainer>
        {heading && <PageHeading>{heading}</PageHeading>}
        <div style={{ padding: "2.5rem" }}>Failed to load</div>
      </OpenPositionsContainer>
    );
  }
  if (!data)
    return (
      <OpenPositionsContainer>
        {heading && <PageHeading>{heading}</PageHeading>}
        <div style={{ padding: "2.5rem" }}>Loading...</div>
      </OpenPositionsContainer>
    );

  const { positions = [] } = data;
  // Exclude position with ID: 226017 (Candidatura spontanea)
  const positionsToShow = positions.filter((p) => p.id != ID_TO_EXCLUDE);

  // Get candidatura spontanea application url
  const candidaturaSpontanea = positions.filter((p) => p.id == ID_TO_EXCLUDE);
  const jobApplicationUrl = candidaturaSpontanea.length
    ? candidaturaSpontanea[0].web_url
    : null;

  // Get array of unique countries
  const countries = positions.map((p) => p.location?.country);
  const filterValues = Array.from(new Set(countries));

  return (
    <OpenPositionsContainer>
      {heading && <PageHeading as="h1">{heading}</PageHeading>}
      <Facets />
      <div style={{ padding: "2.5rem" }}>
        {filterValues &&
          filterValues.length > 1 &&
          filterValues.sort().join(", ")}
      </div>

      <OpenPositionsList>
        {positionsToShow
          ?.filter((position) => {
            if (position?.location?.country) {
              return isSelected("Country", position.location.country);
            } else {
              return false;
            }
          })
          .map((position) => (
            <OpenPositionCard key={position.id} {...position} />
          ))}
      </OpenPositionsList>

      {/* TODO fix types  */}
      {/* @ts-ignore  */}
      {data && jobApplication && (
        <JobApplication {...jobApplication} url={jobApplicationUrl} />
      )}
    </OpenPositionsContainer>
  );
};

export default OpenPositions;
